const WOD_MESSAGES = {
    'it-IT' : {
        'welcome' : 'Il generatore definitivo e infernale di WOD<br>per i metallari amanti del crossfit',
        'give_it_to_me' : 'Dammi il mio WOD!',
        'give_me_another_one' : 'Dammene un altro!',
        'die' : 'Muori :)',
        'repeat' : 'Ripeti',
        labels: {
            'so-easy': 'Facilissimo',
            'easy': 'Facile',
            'medium': 'Medio',
            'hard': 'Difficile',
            'impossible': 'Impossibile',
        },
    },
    'en-EN' : {
        'welcome' : 'The ultimate crossfit WOD generator from hell',
        'give_it_to_me' : 'Give it to me!',
        'give_me_another_one' : 'Give me another one!',
        'die' : 'Die :)',
        'repeat' : 'Repeat',
        labels: {
            'so-easy': 'So so easy',
            'easy': 'Easy',
            'medium': 'Medium',
            'hard': 'Hard',
            'impossible': 'Impossible',
        },
    },
};

export default WOD_MESSAGES;


// WEBPACK FOOTER //
// ./src/shared/messages.js